import { init as initMainSearchProducts } from "../sections/main-search-products";
import { init as initSortBy } from "../sections/sort-by";

export function init() {
  const productsSection = document.querySelector(
    ".shopify-section.main-search-products"
  );
  if (productsSection instanceof HTMLElement) {
    initMainSearchProducts(productsSection);
  }
  const controlsSection = document.querySelector(
    ".shopify-section.sort-by"
  );
  if (controlsSection instanceof HTMLElement) {
    initSortBy(controlsSection);
  }
}
